import { msg } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { createFileRoute } from '@tanstack/react-router'
import { SettingsPage } from '~/components/settings/settings-page'
import { StageTemplateEditor } from '~/components/settings/stage-template-editor'
import { titleFor } from '~/lib/route-title'
import { useWorkspace } from '~/lib/workspace-context'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/settings/stages')({
  component: StagesSettings,
  head: () => ({ meta: [{ title: titleFor(msg`Stages`) }] }),
})

/** Stage templates affect future projects only; editing is admin-only. */
function StagesSettings() {
  const isAdmin = useWorkspace().role === 'admin'

  return (
    <SettingsPage>
      <p className="text-muted-foreground text-sm">
        <Trans>Changes apply to future projects; existing projects keep their stages.</Trans>
      </p>
      {!isAdmin && (
        <p className="text-muted-foreground text-sm">
          <Trans>Only workspace admins can change stages.</Trans>
        </p>
      )}
      <StageTemplateEditor />
    </SettingsPage>
  )
}
